var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 9C12.75 10.275 11.775 11.25 10.5 11.25C9.225 11.25 8.25 10.275 8.25 9C8.25 7.725 9.225 6.75 10.5 6.75C11.775 6.75 12.75 7.725 12.75 9ZM16.5 5.25V13.5C16.5 14.325 15.825 15 15 15H3C2.175 15 1.5 14.325 1.5 13.5V5.25C1.5 4.425 2.175 3.75 3 3.75V3H6V3.75H7.5L8.25 2.25H12.75L13.5 3.75H15C15.825 3.75 16.5 4.425 16.5 5.25ZM5.625 6.75C5.625 6.15 5.1 5.625 4.5 5.625C3.9 5.625 3.375 6.15 3.375 6.75C3.375 7.35 3.9 7.875 4.5 7.875C5.1 7.875 5.625 7.35 5.625 6.75ZM14.25 9C14.25 6.9 12.6 5.25 10.5 5.25C8.4 5.25 6.75 6.9 6.75 9C6.75 11.1 8.4 12.75 10.5 12.75C12.6 12.75 14.25 11.1 14.25 9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.990aa2a4074b1e6cf4db82d480c46ec9.svg";
export { ForwardRef as ReactComponent };